import type { UseAsyncDataResT } from '@dr.pogodin/react-utils';

import { getUser } from 'services';
import { type UserT, useAsyncCollection } from 'utils';

export function useUser(
  id: string,
): UseAsyncDataResT<UserT> {
  return useAsyncCollection(
    id,
    'users.map',
    getUser,
  );
}
